import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { isMobile } from "react-device-detect";
import { OverlayTrigger, Tooltip, Form } from "react-bootstrap";

import { hexToRGBA } from '../../../../utils/theme';

const StyledGroup = styled(Form.Group)`
  width: 30%;

  margin-bottom: 0!important;
  padding-left: 0;
  padding-right: 0;

  input:checked + label,
  input:not(:checked) + label {
    display: inline-block;

    font-family: 'Arial';
    font-size: 14px;
    line-height: calc(1.42857rem * (14 / 16));
    color: #424242;

    cursor: pointer;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
  }
`;

const StyledCheck = styled(Form.Check)`
  margin-right: 24px;

  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 12px;
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 10px;
  padding-bottom: 10px;

  border-bottom: 1px solid ${hexToRGBA('#000000', 0.1)};

  ${({ hideDivider }) => hideDivider && css`
    border-bottom: none;
  `};

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

const StyledQuestion = styled.div`
  width: 70%;
  padding-right: 24px;
  font-family: 'Arial';
  font-size: 14px;
  line-height: calc(1.42857rem * (14 / 16));
  color: #424242;

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
  }
`; 

function Switch({
  id,
  hideDivider,
  hint,
  label,
  labelOn = "Label ON",
  labelOff = "Label OFF",
  valueOn,
  valueOff,
  value,
  onChange,
  onMouseEnter,
  onMouseLeave,
}) {
  const handleMouseEnter = useCallback(() => {
    onMouseEnter && onMouseEnter({ label, hint });
  }, [onMouseEnter, label, hint]);

  const overlayTriggerProps = useMemo(() => {
    const props = {
      placement: isMobile ? "top" : "right-start",
      delay: { show: 0, hide: 0 },
      trigger: ["hover", "focus"],
      overlay: (
        <Tooltip id={`tooltip-${id}`} className="hintTooltip">
          {hint}
        </Tooltip>
      ),
      show: false,
    };

    return props;
  }, [id, hint]);

  return (
    <OverlayTrigger {...overlayTriggerProps}>
      <StyledWrapper
        hideDivider={hideDivider}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <StyledQuestion>
          <span>{label}</span>
        </StyledQuestion>
        <StyledGroup controlId={id}>
          <StyledCheck
            inline
            id={`${id}1`}
            label={labelOff}
            name={id}
            type="radio"
            value={valueOff}
            checked={value === valueOff}
            onChange={onChange}
          />
          <StyledCheck
            inline
            id={`${id}2`}
            label={labelOn}
            name={id}
            type="radio"
            value={valueOn}
            checked={value === valueOn}
            onChange={onChange}
          />
        </StyledGroup>
      </StyledWrapper>
    </OverlayTrigger>
  );
}

export default Switch;
